import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode, faCreditCard } from "@fortawesome/free-solid-svg-icons";
import CreditCardForm from "../form-credit-card";
import { IndexHook } from "./hooks";
import { BtnCustom } from "../../../../components/button/button";
import reqEmpresaItens from "../../../../services/reqMultiTenant/reqEmpresaItens";
import { toast } from "react-toastify";
import OrderSummary from "../Main/order-sumary";

const PaymentTypeContracting = () => {
	const [paymentMethod, setPaymentMethod] = useState("credit");
	const [empresaItensDemo, setEmpresaItensDemo] = useState([]);

	const { handleCreateBilling, loading } = IndexHook();

	useEffect(() => {
		fetchPedido();
	}, []);

	const fetchPedido = async () => {
		try {
			const responseItens = await reqEmpresaItens.listOrderSumary();

			setEmpresaItensDemo(responseItens.data);
		} catch (error) {
			toast.error("Erro ao carregar itens de assinatura.");
		}
	};

	const handlePaymentChange = (method) => {
		setPaymentMethod(method);
	};

	return empresaItensDemo && empresaItensDemo.length > 0 ? (
		<>
			<header className="flex flex-col mb-3 bg-gray-50 rounded-lg shadow-md p-4">
				<h1 className="text-2xl font-bold text-gray-800">Finalizar Compra</h1>

				<div className="flex items-center mt-4 gap-4">
					<button
						className={`flex items-center w-40 h-12 gap-2 p-2 rounded-md border transition-all ${
							paymentMethod === "boleto"
								? "!border-customBlue-500 bg-customPalette-100 hover:bg-customPalette-200"
								: "!border-gray-300 hover:bg-gray-100"
						}`}
						onClick={() => handlePaymentChange("boleto")}
					>
						<FontAwesomeIcon icon={faBarcode} />
						<span>Boleto</span>
					</button>

					<button
						className={`flex items-center h-12 w-40 gap-2 p-2 rounded-md border transition-all ${
							paymentMethod === "credit"
								? "!border-customBlue-500 bg-customPalette-100 hover:bg-customPalette-200"
								: "!border-gray-300 hover:bg-gray-100"
						}`}
						onClick={() => handlePaymentChange("credit")}
					>
						<FontAwesomeIcon icon={faCreditCard} />
						<span>Cartão</span>
					</button>
				</div>
			</header>
			<main className="flex flex-col mb-4 bg-gray-50 rounded-lg shadow-md p-4">
				{paymentMethod === "credit" ? (
					<CreditCardForm empresaItensDemo={empresaItensDemo} />
				) : (
					<>
						<OrderSummary itens={empresaItensDemo} />
						<BtnCustom
							className="btn btn-sm btn-primary w-60 mt-3 mb-2"
							onClick={(e) => handleCreateBilling()}
							text={loading ? "Gerando boleto aguarde..." : "Gerar Boleto"}
							isSubmitting={loading}
						/>
					</>
				)}
			</main>
		</>
	) : (
		<div className="flex flex-col items-center justify-center py-10 gap-4">
			<span className="text-gray-500">Nenhum item encontrado.</span>
			<BtnCustom className="btn btn-sm btn-primary w-60" onClick={fetchPedido} text="Tentar Novamente" />
		</div>
	);
};

export default PaymentTypeContracting;
